<div class="w-100 p-3">
  <h3 class="mb-4 fw-bold">{{"title_account_manager"|translate}}</h3>
  <div>
    <span class="btn btn-sm btn-primary rounded-1 me-2 mb-2"
      (click)="sharedService.pwaInstall('/assets/manifest.webmanifest')">
      <div class="d-flex align-items-center">
        <i class="bi bi-gear"></i>
        <span class="ms-2">{{'setup_pwa_erp'|translate}}</span>
      </div>
    </span>
    <span class="btn btn-sm btn-primary rounded-1 me-2 mb-2"
      (click)="sharedService.pwaInstall('/assets/manifest-attendance.webmanifest')">
      <div class="d-flex align-items-center">
        <i class="bi bi-gear"></i>
        <span class="ms-2">{{'setup_pwa_attendance'|translate}}</span>
      </div>
    </span>
    <span class="btn btn-sm btn-primary rounded-1 me-2 mb-2"
      (click)="sharedService.pwaInstall('/assets/manifest-station-faceid.webmanifest')">
      <div class="d-flex align-items-center">
        <i class="bi bi-gear"></i>
        <span class="ms-2">{{'setup_pwa_attendance_station_faceid'|translate}}</span>
      </div>
    </span>
    <span class="btn btn-sm btn-primary rounded-1 me-2 mb-2"
      (click)="sharedService.pwaInstall('/assets/manifest-station-qrcode.webmanifest')">
      <div class="d-flex align-items-center">
        <i class="bi bi-gear"></i>
        <span class="ms-2">{{'setup_pwa_attendance_station_qrcode'|translate}}</span>
      </div>
    </span>
    <span class="btn btn-sm btn-primary rounded-1 me-2 mb-2"
      (click)="sharedService.pwaInstall('/assets/manifest-chat.webmanifest')">
      <div class="d-flex align-items-center">
        <i class="bi bi-gear"></i>
        <span class="ms-2">{{'setup_pwa_chat'|translate}}</span>
      </div>
    </span>
  </div>
</div>